import { render, staticRenderFns } from "./AdminMerchantsView.vue?vue&type=template&id=7de851da&scoped=true"
import script from "./AdminMerchantsView.vue?vue&type=script&lang=js"
export * from "./AdminMerchantsView.vue?vue&type=script&lang=js"
import style0 from "./AdminMerchantsView.vue?vue&type=style&index=0&id=7de851da&prod&lang=scss&scoped=true"
import style1 from "./AdminMerchantsView.vue?vue&type=style&index=1&id=7de851da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de851da",
  null
  
)

export default component.exports